import React, { useState, useEffect } from "react";
import { FaTimes } from "react-icons/fa";
import LeadForm from "./LeadForm";
import "./LeadPopup.css";

const LeadPopup = () => {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("leadPopupDismissed")) return;
    const timer = setTimeout(() => setVisible(true), 8000);
    return () => clearTimeout(timer);
  }, []);

  const close = () => {
    setVisible(false);
    setDismissed(true);
    sessionStorage.setItem("leadPopupDismissed", "1");
  };

  if (dismissed || !visible) return null;

  return (
    <div className="lead-popup-overlay" onClick={close}>
      <div className="lead-popup-box" onClick={(e) => e.stopPropagation()}>
        <button className="lead-popup-close" onClick={close} aria-label="Close"><FaTimes /></button>
        <div className="lead-popup-offer">
          <span className="lead-popup-badge">Limited Offer</span>
          <h2>Get Your Business Website Starting at ₹2,500</h2>
          <p>Basic websites from ₹2,500. WhatsApp, Google Maps & contact form included. Free consultation!</p>
        </div>
        <LeadForm compact source="popup" onSuccess={close} />
      </div>
    </div>
  );
};

export default LeadPopup;
